import { render, staticRenderFns } from "./StartLayout.vue?vue&type=template&id=4cce3360&"
import script from "./StartLayout.vue?vue&type=script&lang=js&"
export * from "./StartLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports